import HTTP from "@/utils/http";
export default {
  namespaced: true,
  state: {
    wallets: [],
    mnemonic: [],
    transaction: [],
    balance: [],
  },
  mutations: {
    SET_WALLETS(state, wallets) {
      state.wallets = wallets || [];
    },
    SET_MNEMONIC(state, mnemonic) {
      state.mnemonic = mnemonic || [];
    },
    SET_TRANSACTION(state, transaction) {
      state.transaction = transaction || [];
    },
    SET_BALANCE(state, balance) {
      state.balance = balance || [];
    },
  },
  actions: {
    refrushWallet({ dispatch }) {
      dispatch("getBalance");
      dispatch("getTransaction");
    },
    async getWallets({ commit }) {
      const res = await HTTP({ method: "get", url: "/wallet" });
      commit("SET_WALLETS", res);
    },
    async createWallets({ commit }, params) {
      const res = await HTTP({ method: "post", url: "/wallet", data: params });
      commit("SET_MNEMONIC", res);
    },
    async getBalance({ commit }) {
      const res = await HTTP({ method: "get", url: "/wallet/balance" });
      console.log(res);
      commit("SET_BALANCE", res);
    },
    async getTransaction({ commit },params) {
      const res = await HTTP({ method: "get", url: "/transaction/history",params });
      console.log(res);
      commit("SET_TRANSACTION", res);
    },
    /* eslint-disable */
    async getTransactionItem({}, id) {
      return await HTTP({ method: "get", url: `/transaction/${id}` });
    },
    getFee({}, params) {
      return HTTP({ method: "post", url: "/transaction/fee", data: params });
    },
    sendTransaction({}, params) {
      return HTTP({
        method: "post",
        url: "/transaction/send/auto",
        data: params,
      });
    },
    // 发送激活交易
    async sendActivation({}, data) {
      return await HTTP({ method: "post", url: `/transaction/binding/create`,data});
    },
    // 查询激活交易  
    async queryActivation({}, data) {
      return await HTTP({ method: "post", url: `/transaction/binding/status`,data});
    }
    /* eslint-disable */
  },
};
